var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Add Artist" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _c("Button", {
                  attrs: { variant: "default", label: "Cancel" },
                  on: { clicked: _vm.goBack }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "form-wizard",
                  {
                    ref: "formWizard",
                    attrs: {
                      shape: "tab",
                      color: "#3498db",
                      title: "",
                      subtitle: ""
                    },
                    on: { "on-complete": _vm.onCompleteSave },
                    scopedSlots: _vm._u([
                      {
                        key: "footer",
                        fn: function(props) {
                          return [
                            _c(
                              "div",
                              { staticClass: "wizard-footer-left" },
                              [
                                props.activeTabIndex > 0
                                  ? _c(
                                      "wizard-button",
                                      {
                                        style: props.fillButtonStyle,
                                        nativeOn: {
                                          click: function($event) {
                                            return props.prevTab()
                                          }
                                        }
                                      },
                                      [_vm._v("Previous")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "wizard-footer-right" },
                              [
                                !props.isLastStep
                                  ? _c(
                                      "wizard-button",
                                      {
                                        staticClass: "wizard-footer-right",
                                        style: props.fillButtonStyle,
                                        nativeOn: {
                                          click: function($event) {
                                            return props.nextTab()
                                          }
                                        }
                                      },
                                      [_vm._v("Next")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                props.isLastStep
                                  ? _c(
                                      "wizard-button",
                                      {
                                        staticClass:
                                          "wizard-footer-right finish-button",
                                        style: props.fillButtonStyle,
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.isDraft = false
                                            props.nextTab()
                                          }
                                        }
                                      },
                                      [_vm._v("Publish")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                props.isLastStep
                                  ? _c(
                                      "wizard-button",
                                      {
                                        staticClass:
                                          "wizard-footer-right draft-button",
                                        style: props.fillButtonStyle,
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.isDraft = true
                                            props.nextTab()
                                          }
                                        }
                                      },
                                      [_vm._v("Save as Draft")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Profile Details",
                          "before-change": function() {
                            return _vm.validateStep("step1")
                          }
                        }
                      },
                      [
                        _c("Step1", {
                          ref: "step1",
                          on: { "on-validate": _vm.mergePartialModels }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Bank Info",
                          "before-change": function() {
                            return _vm.validateStep("step2")
                          }
                        }
                      },
                      [
                        _c("Step2", {
                          ref: "step2",
                          on: { "on-validate": _vm.mergePartialModels }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bbc31c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbc31c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/AddArtist.vue
// module id = null
// module chunks = 